import BeCuponUtils from "@/utils/Utils";
import Store from "../store/store.js";

export default class Coupons {
  static async retrieve(axios, id) {
    const response = await axios.post(
      "/graphql/",
      `query {
        couponsRetrieve(id: ${id}) {
          active
          soldOut
          id
          title
          subTitle
          categories {
            id
            name
          }
          images {
            id
            url
          }   
          initialDate
          expirationDate
          description
          discount
          affiliate
          distinguished
          hot
          new
          price
          saveValue
          value
          maximumSales
          alwaysShow
          available
          isActive
          restSales
          couponAmount
          maximumCarPurchase
          maximumCarPurchaseUser
          couponAmountActive
          amountActives
          hideAuto
          newsLetter
          showApp
          free
          datetimeHideAutoStart
          datetimeHideAutoOff         
          lat
          lng
          clientType {
            id
            name
            desc
          }
          cities {
            id
            name
            region {
              id
              name
              country {
                id 
                name
              }
            }
          }
          companies {
            id
            name
            description
          }
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );
    if (response.data.data.couponsRetrieve.hideAuto) {
      response.data.data.couponsRetrieve.datetimeHideAutoDateStart = response.data.data.couponsRetrieve.datetimeHideAutoStart.split(
        "T"
      )[0];
      response.data.data.couponsRetrieve.datetimeHideAutoTimeStart = response.data.data.couponsRetrieve.datetimeHideAutoStart
        .split("T")[1]
        .substr(0, 5);

      response.data.data.couponsRetrieve.datetimeHideAutoDateOff = response.data.data.couponsRetrieve.datetimeHideAutoOff.split(
        "T"
      )[0];
      response.data.data.couponsRetrieve.datetimeHideAutoTimeOff = response.data.data.couponsRetrieve.datetimeHideAutoOff
        .split("T")[1]
        .substr(0, 5);
    }

    response.data.data.couponsRetrieve.compressed = {
      country: response.data.data.couponsRetrieve.cities[0]
        ? response.data.data.couponsRetrieve.cities[0].region.country
        : "",
      regions: BeCuponUtils.getDistinct(
        response.data.data.couponsRetrieve.cities.map((city) => city.region)
      ),
      cities: response.data.data.couponsRetrieve.cities,
      companies: response.data.data.couponsRetrieve.companies,
      categories: response.data.data.couponsRetrieve.categories,
      clientType: response.data.data.couponsRetrieve.clientType,
    };

    response.data.data.couponsRetrieve.country = response.data.data
      .couponsRetrieve.cities[0]
      ? response.data.data.couponsRetrieve.cities[0].region.country.id
      : "";
    response.data.data.couponsRetrieve.regions = BeCuponUtils.getDistinct(
      response.data.data.couponsRetrieve.cities.map((city) => city.region.id)
    );
    // response.data.data.couponsRetrieve.cities = response.data.data.couponsRetrieve.cities.map(city => city.id);
    response.data.data.couponsRetrieve.companies = response.data.data.couponsRetrieve.companies.map(
      (company) => company.id
    );
    response.data.data.couponsRetrieve.categories = response.data.data.couponsRetrieve.categories.map(
      (category) => category.id
    );
    response.data.data.couponsRetrieve.clientType = response.data.data.couponsRetrieve.clientType.map(
      (client) => client.id
    );
    Store.commit(
      "UPDATE_COUPONS_REGION_LIST",
      BeCuponUtils.getDistinct(
        response.data.data.couponsRetrieve.cities.map((city) => city.region.id)
      )
    );
    Store.commit(
      "UPDATE_COUPONS_CITY_LIST",
      response.data.data.couponsRetrieve.cities.map((city) => city.id)
    );

    return response.data.data.couponsRetrieve;
  }

  static async allToCreateCoupon(axios) {
    const response = await axios.post(
      "/graphql/",
      `query{
        couponsList{
          results{
            id
            title
          }
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );

    return response.data.data.couponsList.results.reverse();
  }

  static async all(payload) {
    const response = await payload.axios.post(
      "/graphql/",
      `query{
        couponsList(affiliate:${payload.affiliate}) {
          results {
            id
            title
            subTitle
            soldOut
            categories{
              id
              name
            }
            images {
              id
              url
            }   
            initialDate
            expirationDate
            description
            maximumCarPurchase
            maximumCarPurchaseUser
            discount
            affiliate
            distinguished
            hot
            new
            showApp
            free
            newsLetter
            price
            saveValue
            value
            couponList{
              branchOffices{
                company{
                  name
                }
              }  
            }
            maximumSales
            alwaysShow
            available
            isActive
            restSales
            couponAmount
            couponAmountActive
            amountActives
          }
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );
    console.log(
      "lo que viene...!!!",
      response.data.data.couponsList.results.reverse()
    );
    return response.data.data.couponsList.results.reverse();
  }

  static async allOfBranchOffice(axios, active, branchOffice) {
    const response = await axios.post(
      "/graphql/",
      `query {
        couponsBranchOffice(active: ${active}, branchOfficeId: ${branchOffice}) {
          id
          title
          subTitle
          soldOut
          categories {
            id
            name
          }
          images {
            id
            url
          }
          initialDate
          expirationDate
          description
          discount
          affiliate
          distinguished
          hot
          new
          newsLetter
          free
          price
          saveValue
          value
          couponList{
            branchOffices{
              company{
                name
              }
            }  
          }
          maximumSales
          alwaysShow
          available
          isActive
          restSales
          couponAmount
          couponAmountActive
          amountActives
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );

    return response.data.data.couponsBranchOffice;
  }

  static async allOfCompany(axios, active, company) {
    const response = await axios.post(
      "/graphql/",
      `query {
        couponsCompany(active:${active}, companyId: ${company}) {
          id
          title
          subTitle
          soldOut
          categories {
            id
            name
          }
          images {
            id
            url
          }
          initialDate
          expirationDate
          description
          discount
          affiliate
          distinguished
          hot
          new
          free
          newsLetter
          price
          saveValue
          value
          couponList{
            branchOffices{
              company{
                name
              }
            }  
          }
          maximumSales
          alwaysShow
          available
          isActive
          restSales
          couponAmount
          couponAmountActive
          amountActives
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );

    return response.data.data.couponsCompany;
  }

  static async filter(axios, active, category) {
    const response = await axios.post(
      "/graphql/",
      `query{
        couponsList (active: ${active}, categories: ${category}) {
          results {
            id
            title
            subTitle
            soldOut
            categories{
              id
              name
            }
            images {
              id
              url
            }   
            initialDate
            expirationDate
            description
            discount
            affiliate
            distinguished
            hot
            new
            newsLetter
            price
            saveValue
            value
            free
            couponList{
              branchOffices{
                company{
                  name
                }
              }  
            }
            maximumSales
            alwaysShow
            available
            isActive
            restSales
            couponAmount
            couponAmountActive
            amountActives
          }
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );

    return response.data.data.couponsList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      "/graphql/",
      `mutation{
        deleteCoupons(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );

    return response.data.data.deleteCoupons.ok;
  }

  static async create(
    axios,
    title,
    subTitle,
    description,
    initialDate,
    expirationDate,
    price,
    value,
    saveValue,
    discount,
    affiliate,
    distinguished,
    hot,
    newV,
    categories,
    maximumCarPurchase,
    maximumCarPurchaseUser,
    images,
    maximumSales,
    alwaysShow,
    hideAuto,
    datetimeHideAutoStart,
    datetimeHideAutoOff,
    lat,
    lng,
    clientTypeId,
    cities,
    companies,
    showApp,
    free
  ) {
    const imageField = images !== -1 ? `images: [${images}],` : ``;
    const datetimeStart =
      datetimeHideAutoStart !== null
        ? `datetimeHideAutoStart: "${datetimeHideAutoStart}",`
        : ``;
    const datetimeOff =
      datetimeHideAutoOff !== null
        ? `datetimeHideAutoOff: "${datetimeHideAutoOff}",`
        : ``;
    const latd = lat !== null ? `lat: "${lat}",` : ``;
    const lngd = lng !== null ? `lng: "${lng}",` : ``;
    const newDescrip = description.replace(/(\r\n|\n|\r)/gm, "");
    const response = await axios.post(
      "/graphql/",
      `mutation {
        createCoupons(newCoupons: {
          ${imageField}
          title: "${title}", 
          subTitle: "${subTitle}", 
          description: "${newDescrip}", 
          initialDate: "${initialDate}", 
          expirationDate: "${expirationDate}", 
          price: ${price}, 
          value: ${value}, 
          saveValue: ${saveValue}, 
          cities: ${cities},
          companies: ${companies},
          clientType: ${clientTypeId},
          hideAuto: ${hideAuto},
          ${datetimeStart}
          ${datetimeOff}
          ${latd}
          ${lngd}
          discount: ${discount}, 
          affiliate: ${affiliate},
          distinguished: ${distinguished}, 
          hot: ${hot}, 
          new: ${newV},
          categories: ${categories},
          maximumCarPurchase: ${maximumCarPurchase},
          maximumCarPurchaseUser: ${maximumCarPurchaseUser},
          maximumSales: ${maximumSales},
          alwaysShow: ${alwaysShow},
          showApp: ${showApp},
          free: ${free},
        }) {
          ok
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );

    return response.data.data.createCoupons.ok;
  }

  static async edit(payload) {
    const imageField =
      payload.images !== -1 ? `images: [${payload.images}],` : ``;
    const datetimeStart =
      payload.datetimeHideAutoStart !== null
        ? `datetimeHideAutoStart: "${payload.datetimeHideAutoStart}",`
        : ``;
    const datetimeOff =
      payload.datetimeHideAutoOff !== null
        ? `datetimeHideAutoOff: "${payload.datetimeHideAutoOff}",`
        : ``;
    const latd = payload.lat !== null ? `lat: "${payload.lat}",` : ``;
    const lngd = payload.lng !== null ? `lng: "${payload.lng}",` : ``;
    const newDescrip = payload.description?.replace(/(\r\n|\n|\r)/gm, "");
    const response = await payload.axios.post(
      "/graphql/",
      `mutation {
        updateCoupons(newCoupons: {
          ${imageField}
          id: "${payload.id}",
          title: "${payload.title}", 
          subTitle: "${payload.subTitle}", 
          description: "${newDescrip}", 
          initialDate: "${payload.initialDate}", 
          expirationDate: "${payload.expirationDate}", 
          price: ${payload.price}, 
          value: ${payload.value}, 
          saveValue: ${payload.saveValue}, 
          cities: ${payload.cities},
          companies: ${payload.companies},
          clientType: ${payload.clientTypeId},
          hideAuto: ${payload.hideAuto},
          ${datetimeStart}
          ${datetimeOff}
          ${latd}
          ${lngd}
          discount: ${payload.discount}, 
          affiliate: ${payload.affiliate},
          distinguished: ${payload.distinguished}, 
          hot: ${payload.hot}, 
          new: ${payload.newV},
          categories: ${payload.categories},
          maximumSales: ${payload.maximumSales},
          maximumCarPurchase: ${payload.maximumCarPurchase},
          maximumCarPurchaseUser: ${payload.maximumCarPurchaseUser},
          alwaysShow: ${payload.alwaysShow},
          showApp: ${payload.showApp}
          free: ${payload.free}
        }) {
          ok
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );

    return response.data.data.updateCoupons.ok;
  }
}
